// Full-document render of the sealy BasicPage: PageSkeleton (the React
// document shell) wrapping the existing basic-page body assembly. The legacy
// template overrode BOTH {% block header %} and {% block footer %} to empty,
// so the site header and footer are suppressed here (header/footer={false}),
// and with the header went the _messages.html include -- messages={false}
// omits the flash-messages block (the server side skips the queue drain via
// include_messages=False to match).
import React from "react";

import { templates } from "@reactivated";

import { BasicPageBody } from "../components/BasicPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes
// PageSkeleton, which is typed with mutable reactivated props (see
// PageSkeleton). The body template accepts Immutable props, to which these
// are assignable.
export const Template = (
    props: templates.BasicPageTemplate,
): React.JSX.Element => (
    <PageSkeleton
        pageChrome={props.page_chrome}
        header={false}
        footer={false}
        messages={false}
    >
        <BasicPageBody page={props.page} />
    </PageSkeleton>
);
